import { prop } from "@rxweb/reactive-form-validators";

export enum EntityTranslate {
  Profile = 'Profile',
  Category = 'Category',
  Location = 'Location'
}

export interface LanguageOption {
  code: string;
  name: string;
}

export interface OriginalData {
  previousClients: any[];
  setList: any[];
  testimonials: any[];
}

export interface TranslateData {
  langContentId?: number;  
  objId: string;
  objName: string;
  lang: string;
  title?: string;
  reasons?: string[];
  bioRewrites?: string;
  previousClients?: string[];
  setList?: string[];
  testimonials?: {text: string; subText: string}[];
  topDescription?: string;
  description?: string;
  faqs?: {text: string; subText: string}[];
  metaTitle: string;
  metaDescription: string;
  isPublish: boolean;
  extendData?: string;
  friendlyUrl: string;
  leftBlog?: string;
  rightBlog?: string;
  askAnExpert?: string;
}

export class WPLangContent {
    langContentId: number | null;
    revisionId: number | null;
    @prop()
    lang: string | null;
    objName: string;
    objId: string;
    @prop()
    title?: string;
    @prop()
    bios?: string;
    @prop()
    reasons?: string;
    @prop()
    setlist?: string;
    @prop()
    previousClient?: string;
    @prop()
    topDescription?: string;
    @prop()
    description?: string;
    @prop()
    faqs?: string;
    @prop()
    seoTitle?: string;
    @prop()
    seoDescription?: string;
    @prop()
    isPublish?: boolean;
    extendData?: string;
    @prop()
    friendlyUrl: string;
}

export enum LoadDetailType {
  Full = 'Full',
  SkipCheckDuplicate = 'SkipCheckDuplicate',
  KeepTranslation = 'KeepTranslation',
  SkipUnsavedPopup = 'SkipUnsavedPopup',
}
